import {
  atom,
  useRecoilState,
  selector, useRecoilValue
} from 'recoil'
import moment from 'moment'
import { sitesState } from 'store'

import { PAGE_SIZE } from './use-advertisements'

const filtersState = atom({
  key: 'AdvertisementsFilters',
  default: {
    publish_start_at: null,
    publish_end_at: null,
    verbatim: '',
    statuses: [],
  },
})

const sortState = atom({
  key: 'AdvertisementsSort',
  default: {
    by: 'starts_at',
    direction: 'desc'
  }
})

const queryVariablesState = selector({
  key: 'AdvertisementsQueryVariables',
  get: ({ get }) => {
    const filters = get(filtersState)
    const {selected} = get(sitesState)
    const sort = get(sortState)

    return {
      site_sf_ids: selected.map(({ sf_id }) => sf_id),
      verbatim: filters.verbatim,
      statuses: filters.statuses,
      publish_start_at: filters.publish_start_at ? moment(filters.publish_start_at).format() : null,
      publish_end_at: filters.publish_end_at ? moment(filters.publish_end_at).format() : null,
      sort_by: sort.by,
      sort_direction: sort.direction,
      limit: PAGE_SIZE
    }
  }
})

export const useQueryVariables = () => useRecoilValue(queryVariablesState)

export const useSort = () => {
  const [{ direction, by }, setSort] = useRecoilState(sortState)
  return [
    { direction, by },
    (sort) => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc'
        setSort({ by: sort, direction: newDirection })
      } else {
        setSort({ by: sort, direction: 'asc' })
      }
    },
  ]
}

const useFilters = () => {
  return useRecoilState(filtersState)
}

export default useFilters
